(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/sportsbook/components/sbtech-api-impl/assets/javascripts/constants.js') >= 0) return;  svs.modules.push('/modules/sportsbook/components/sbtech-api-impl/assets/javascripts/constants.js'); "use strict";

const oddsetWagerModels = [{
  title: 'Singel',
  type: 'Single',
  desc: null,
  count: 1,
  amount: 1,
  a: 1
}, {
  title: 'Dubbel',
  type: 'Combo',
  desc: null,
  count: 2,
  amount: 1,
  a: 2
}, {
  title: 'Trippel',
  type: 'Combo',
  desc: null,
  count: 3,
  amount: 1,
  a: 3
}, {
  title: 'Fyrling',
  type: 'Combo',
  desc: null,
  count: 4,
  amount: 1,
  a: 4
}, {
  title: 'Femling',
  type: 'Combo',
  desc: null,
  count: 5,
  amount: 1,
  a: 5
}, {
  title: 'Sexling',
  type: 'Combo',
  desc: null,
  count: 6,
  amount: 1,
  a: 6
}, {
  title: 'Sjuling',
  type: 'Combo',
  desc: null,
  count: 7,
  amount: 1,
  a: 7
}, {
  title: 'Åttling',
  type: 'Combo',
  desc: null,
  count: 8,
  amount: 1,
  a: 8
}, {
  title: 'Niling',
  type: 'Combo',
  desc: null,
  count: 9,
  amount: 1,
  a: 9
}, {
  title: 'Tioling',
  type: 'Combo',
  desc: null,
  count: 10,
  amount: 1,
  a: 10
}, {
  title: 'Elvling',
  type: 'Combo',
  desc: null,
  count: 11,
  amount: 1,
  a: 11
}, {
  title: 'Tolvling',
  type: 'Combo',
  desc: null,
  count: 12,
  amount: 1,
  a: 12
}, {
  title: 'Trettonling',
  type: 'Combo',
  desc: null,
  count: 13,
  amount: 1,
  a: 13
}, {
  title: 'Fjortonling',
  type: 'Combo',
  desc: null,
  count: 14,
  amount: 1,
  a: 14
}, {
  title: 'Femtonling',
  type: 'Combo',
  desc: null,
  count: 15,
  amount: 1,
  a: 15
}, {
  title: 'Sextonling',
  type: 'Combo',
  desc: null,
  count: 16,
  amount: 1,
  a: 16
}, {
  title: 'Sjuttonling',
  type: 'Combo',
  desc: null,
  count: 17,
  amount: 1,
  a: 17
}, {
  title: 'Artonling',
  type: 'Combo',
  desc: null,
  count: 18,
  amount: 1,
  a: 18
}, {
  title: 'Nittonling',
  type: 'Combo',
  desc: null,
  count: 19,
  amount: 1,
  a: 19
}, {
  title: 'Tjugoling',
  type: 'Combo',
  desc: null,
  count: 20,
  amount: 1,
  a: 20
}, {
  title: 'System 2/3',
  type: 'System2from3',
  desc: '3 dubblar',
  count: 2,
  amount: 3,
  a: 3
}, {
  title: 'System 2/4',
  type: 'System2from4',
  desc: '6 dubblar',
  count: 2,
  amount: 6,
  a: 4
}, {
  title: 'System 3/4',
  type: 'System3from4',
  desc: '4 tripplar',
  count: 3,
  amount: 4,
  a: 4
}, {
  title: 'System 2/5',
  type: 'System2from5',
  desc: '10 dubblar',
  count: 2,
  amount: 10,
  a: 5
}, {
  title: 'System 3/5',
  type: 'System3from5',
  desc: '10 tripplar',
  count: 3,
  amount: 10,
  a: 5
}, {
  title: 'System 4/5',
  type: 'System4from5',
  desc: '5 fyrlingar',
  count: 4,
  amount: 5,
  a: 5
}, {
  title: 'System 2/6',
  type: 'System2from6',
  desc: '15 dubblar',
  count: 2,
  amount: 15,
  a: 6
}, {
  title: 'System 3/6',
  type: 'System3from6',
  desc: '20 tripplar',
  count: 3,
  amount: 20,
  a: 6
}, {
  title: 'System 4/6',
  type: 'System4from6',
  desc: '15 fyrlingar',
  count: 4,
  amount: 15,
  a: 6
}, {
  title: 'System 5/6',
  type: 'System5from6',
  desc: '6 femlingar',
  count: 5,
  amount: 6,
  a: 6
}, {
  title: 'System 2/7',
  type: 'System2from7',
  desc: '21 dubblar',
  count: 2,
  amount: 21,
  a: 7
}, {
  title: 'System 3/7',
  type: 'System3from7',
  desc: '35 tripplar',
  count: 3,
  amount: 35,
  a: 7
}, {
  title: 'System 4/7',
  type: 'System4from7',
  desc: '35 fyrlingar',
  count: 4,
  amount: 35,
  a: 7
}, {
  title: 'System 5/7',
  type: 'System5from7',
  desc: '21 femlingar',
  count: 5,
  amount: 21,
  a: 7
}, {
  title: 'System 6/7',
  type: 'System6from7',
  desc: '7 sexlingar',
  count: 6,
  amount: 7,
  a: 7
}, {
  title: 'System 2/8',
  type: 'System2from8',
  desc: '28 dubblar',
  count: 2,
  amount: 28,
  a: 8
}, {
  title: 'System 3/8',
  type: 'System3from8',
  desc: '56 tripplar',
  count: 3,
  amount: 56,
  a: 8
}, {
  title: 'System 4/8',
  type: 'System4from8',
  desc: '70 fyrlingar',
  count: 4,
  amount: 70,
  a: 8
}, {
  title: 'System 5/8',
  type: 'System5from8',
  desc: '56 femlingar',
  count: 5,
  amount: 56,
  a: 8
}, {
  title: 'System 6/8',
  type: 'System6from8',
  desc: '28 sexlingar',
  count: 6,
  amount: 28,
  a: 8
}, {
  title: 'System 7/8',
  type: 'System7from8',
  desc: '8 sjulingar',
  count: 7,
  amount: 8,
  a: 8
}, {
  title: 'System 2/9',
  type: 'System2from9',
  desc: '36 dubblar',
  count: 2,
  amount: 36,
  a: 9
}, {
  title: 'System 3/9',
  type: 'System3from9',
  desc: '84 tripplar',
  count: 3,
  amount: 84,
  a: 9
}, {
  title: 'System 4/9',
  type: 'System4from9',
  desc: '126 fyrlingar',
  count: 4,
  amount: 126,
  a: 9
}, {
  title: 'System 5/9',
  type: 'System5from9',
  desc: '126 femlingar',
  count: 5,
  amount: 126,
  a: 9
}, {
  title: 'System 6/9',
  type: 'System6from9',
  desc: '84 sexlingar',
  count: 6,
  amount: 84,
  a: 9
}, {
  title: 'System 7/9',
  type: 'System7from9',
  desc: '36 sjulingar',
  count: 7,
  amount: 36,
  a: 9
}, {
  title: 'System 8/9',
  type: 'System8from9',
  desc: '9 åttlingar',
  count: 8,
  amount: 9,
  a: 9
}, {
  title: 'System 2/10',
  type: 'System2from10',
  desc: '45 dubblar',
  count: 2,
  amount: 45,
  a: 10
}, {
  title: 'System 3/10',
  type: 'System3from10',
  desc: '120 tripplar',
  count: 3,
  amount: 120,
  a: 10
}, {
  title: 'System 4/10',
  type: 'System4from10',
  desc: '210 fyrlingar',
  count: 4,
  amount: 210,
  a: 10
}, {
  title: 'System 5/10',
  type: 'System5from10',
  desc: '252 femlingar',
  count: 5,
  amount: 252,
  a: 10
}, {
  title: 'System 6/10',
  type: 'System6from10',
  desc: '210 sexlingar',
  count: 6,
  amount: 210,
  a: 10
}, {
  title: 'System 7/10',
  type: 'System7from10',
  desc: '120 sjulingar',
  count: 7,
  amount: 120,
  a: 10
}, {
  title: 'System 8/10',
  type: 'System8from10',
  desc: '45 åttlingar',
  count: 8,
  amount: 45,
  a: 10
}, {
  title: 'System 9/10',
  type: 'System9from10',
  desc: '10 nilingar',
  count: 9,
  amount: 10,
  a: 10
}, {
  title: 'System 2/11',
  type: 'System2from11',
  desc: '55 dubblar',
  count: 2,
  amount: 55,
  a: 11
}, {
  title: 'System 3/11',
  type: 'System3from11',
  desc: '165 tripplar',
  count: 3,
  amount: 165,
  a: 11
}, {
  title: 'System 4/11',
  type: 'System4from11',
  desc: '330 fyrlingar',
  count: 4,
  amount: 330,
  a: 11
}, {
  title: 'System 5/11',
  type: 'System5from11',
  desc: '462 femlingar',
  count: 5,
  amount: 462,
  a: 11
}, {
  title: 'System 6/11',
  type: 'System6from11',
  desc: '462 sexlingar',
  count: 6,
  amount: 462,
  a: 11
}, {
  title: 'System 7/11',
  type: 'System7from11',
  desc: '330 sjulingar',
  count: 7,
  amount: 330,
  a: 11
}, {
  title: 'System 8/11',
  type: 'System8from11',
  desc: '165 åttlingar',
  count: 8,
  amount: 165,
  a: 11
}, {
  title: 'System 9/11',
  type: 'System9from11',
  desc: '55 nilingar',
  count: 9,
  amount: 55,
  a: 11
}, {
  title: 'System 10/11',
  type: 'System10from11',
  desc: '11 tilingar',
  count: 10,
  amount: 11,
  a: 11
}, {
  title: 'System 2/12',
  type: 'System2from12',
  desc: '66 dubblar',
  count: 2,
  amount: 66,
  a: 12
}, {
  title: 'System 3/12',
  type: 'System3from12',
  desc: '220 tripplar',
  count: 3,
  amount: 220,
  a: 12
}, {
  title: 'System 4/12',
  type: 'System4from12',
  desc: '495 fyrlingar',
  count: 4,
  amount: 495,
  a: 12
}, {
  title: 'System 5/12',
  type: 'System5from12',
  desc: '792 femlingar',
  count: 5,
  amount: 792,
  a: 12
}, {
  title: 'System 6/12',
  type: 'System6from12',
  desc: '924 sexlingar',
  count: 6,
  amount: 924,
  a: 12
}, {
  title: 'System 7/12',
  type: 'System7from12',
  desc: '792 sjulingar',
  count: 7,
  amount: 792,
  a: 12
}, {
  title: 'System 8/12',
  type: 'System8from12',
  desc: '495 åttlingar',
  count: 8,
  amount: 495,
  a: 12
}, {
  title: 'System 9/12',
  type: 'System9from12',
  desc: '220 nilingar',
  count: 9,
  amount: 220,
  a: 12
}, {
  title: 'System 10/12',
  type: 'System10from12',
  desc: '66 tilingar',
  count: 10,
  amount: 66,
  a: 12
}, {
  title: 'System 11/12',
  type: 'System11from12',
  desc: '12 elvalingar',
  count: 11,
  amount: 12,
  a: 12
}, {
  title: 'System 2/13',
  type: 'System2from13',
  desc: '78 dubblar',
  count: 2,
  amount: 78,
  a: 13
}, {
  title: 'System 3/13',
  type: 'System3from13',
  desc: '286 tripplar',
  count: 3,
  amount: 286,
  a: 13
}, {
  title: 'System 4/13',
  type: 'System4from13',
  desc: '715 fyrlingar',
  count: 4,
  amount: 715,
  a: 13
}, {
  title: 'System 5/13',
  type: 'System5from13',
  desc: '1287 femlingar',
  count: 5,
  amount: 1287,
  a: 13
}, {
  title: 'System 6/13',
  type: 'System6from13',
  desc: '1716 sexlingar',
  count: 6,
  amount: 1716,
  a: 13
}, {
  title: 'System 7/13',
  type: 'System7from13',
  desc: '1716 sjulingar',
  count: 7,
  amount: 1716,
  a: 13
}, {
  title: 'System 8/13',
  type: 'System8from13',
  desc: '1287 åttlingar',
  count: 8,
  amount: 1287,
  a: 13
}, {
  title: 'System 9/13',
  type: 'System9from13',
  desc: '715 nilingar',
  count: 9,
  amount: 715,
  a: 13
}, {
  title: 'System 10/13',
  type: 'System10from13',
  desc: '286 tilingar',
  count: 10,
  amount: 286,
  a: 13
}, {
  title: 'System 11/13',
  type: 'System11from13',
  desc: '78 elvalingar',
  count: 11,
  amount: 78,
  a: 13
}, {
  title: 'System 12/13',
  type: 'System12from13',
  desc: '13 tolvlingar',
  count: 12,
  amount: 13,
  a: 13
}, {
  title: 'System 2/14',
  type: 'System2from14',
  desc: '91 dubblar',
  count: 2,
  amount: 91,
  a: 14
}, {
  title: 'System 3/14',
  type: 'System3from14',
  desc: '364 tripplar',
  count: 3,
  amount: 364,
  a: 14
}, {
  title: 'System 4/14',
  type: 'System4from14',
  desc: '1001 fyrlingar',
  count: 4,
  amount: 1001,
  a: 14
}, {
  title: 'System 5/14',
  type: 'System5from14',
  desc: '2002 femlingar',
  count: 5,
  amount: 2002,
  a: 14
}, {
  title: 'System 6/14',
  type: 'System6from14',
  desc: '3003 sexlingar',
  count: 6,
  amount: 3003,
  a: 14
}, {
  title: 'System 7/14',
  type: 'System7from14',
  desc: '3432 sjulingar',
  count: 7,
  amount: 3432,
  a: 14
}, {
  title: 'System 8/14',
  type: 'System8from14',
  desc: '3003 åttlingar',
  count: 8,
  amount: 3003,
  a: 14
}, {
  title: 'System 9/14',
  type: 'System9from14',
  desc: '2002 nilingar',
  count: 9,
  amount: 2002,
  a: 14
}, {
  title: 'System 10/14',
  type: 'System10from14',
  desc: '1001 tilingar',
  count: 10,
  amount: 1001,
  a: 14
}, {
  title: 'System 11/14',
  type: 'System11from14',
  desc: '364 elvalingar',
  count: 11,
  amount: 364,
  a: 14
}, {
  title: 'System 12/14',
  type: 'System12from14',
  desc: '91 tolvlingar',
  count: 12,
  amount: 91,
  a: 14
}, {
  title: 'System 13/14',
  type: 'System13from14',
  desc: '14 trettonlingar',
  count: 13,
  amount: 14,
  a: 14
}, {
  title: 'System 2/15',
  type: 'System2from15',
  desc: '105 dubblar',
  count: 2,
  amount: 105,
  a: 15
}, {
  title: 'System 3/15',
  type: 'System3from15',
  desc: '455 tripplar',
  count: 3,
  amount: 455,
  a: 15
}, {
  title: 'System 4/15',
  type: 'System4from15',
  desc: '1365 fyrlingar',
  count: 4,
  amount: 1365,
  a: 15
}, {
  title: 'System 5/15',
  type: 'System5from15',
  desc: '3003 femlingar',
  count: 5,
  amount: 3003,
  a: 15
}, {
  title: 'System 6/15',
  type: 'System6from15',
  desc: '5005 sexlingar',
  count: 6,
  amount: 5005,
  a: 15
}, {
  title: 'System 7/15',
  type: 'System7from15',
  desc: '6435 sjulingar',
  count: 7,
  amount: 6435,
  a: 15
}, {
  title: 'System 8/15',
  type: 'System8from15',
  desc: '6435 åttlingar',
  count: 8,
  amount: 6435,
  a: 15
}, {
  title: 'System 9/15',
  type: 'System9from15',
  desc: '5005 nilingar',
  count: 9,
  amount: 5005,
  a: 15
}, {
  title: 'System 10/15',
  type: 'System10from15',
  desc: '3003 tilingar',
  count: 10,
  amount: 3003,
  a: 15
}, {
  title: 'System 11/15',
  type: 'System11from15',
  desc: '1365 elvalingar',
  count: 11,
  amount: 1365,
  a: 15
}, {
  title: 'System 12/15',
  type: 'System12from15',
  desc: '455 tolvlingar',
  count: 12,
  amount: 455,
  a: 15
}, {
  title: 'System 13/15',
  type: 'System13from15',
  desc: '105 trettonlingar',
  count: 13,
  amount: 105,
  a: 15
}, {
  title: 'System 14/15',
  type: 'System14from15',
  desc: '15 fjortonlingar',
  count: 14,
  amount: 15,
  a: 15
}, {
  title: 'System 2/16',
  type: 'System2from16',
  desc: '120 dubblar',
  count: 2,
  amount: 120,
  a: 16
}, {
  title: 'System 3/16',
  type: 'System3from16',
  desc: '560 tripplar',
  count: 3,
  amount: 560,
  a: 16
}, {
  title: 'System 4/16',
  type: 'System4from16',
  desc: '1820 fyrlingar',
  count: 4,
  amount: 1820,
  a: 16
}, {
  title: 'System 5/16',
  type: 'System5from16',
  desc: '4368 femlingar',
  count: 5,
  amount: 4368,
  a: 16
}, {
  title: 'System 6/16',
  type: 'System6from16',
  desc: '8008 sexlingar',
  count: 6,
  amount: 8008,
  a: 16
}, {
  title: 'System 7/16',
  type: 'System7from16',
  desc: '11440 sjulingar',
  count: 7,
  amount: 11440,
  a: 16
}, {
  title: 'System 8/16',
  type: 'System8from16',
  desc: '12870 åttlingar',
  count: 8,
  amount: 12870,
  a: 16
}, {
  title: 'System 9/16',
  type: 'System9from16',
  desc: '11440 nilingar',
  count: 9,
  amount: 11440,
  a: 16
}, {
  title: 'System 10/16',
  type: 'System10from16',
  desc: '8008 tilingar',
  count: 10,
  amount: 8008,
  a: 16
}, {
  title: 'System 11/16',
  type: 'System11from16',
  desc: '4368 elvalingar',
  count: 11,
  amount: 4368,
  a: 16
}, {
  title: 'System 12/16',
  type: 'System12from16',
  desc: '1820 tolvlingar',
  count: 12,
  amount: 1820,
  a: 16
}, {
  title: 'System 13/16',
  type: 'System13from16',
  desc: '560 trettonlingar',
  count: 13,
  amount: 560,
  a: 16
}, {
  title: 'System 14/16',
  type: 'System14from16',
  desc: '120 fjortonlingar',
  count: 14,
  amount: 120,
  a: 16
}, {
  title: 'System 15/16',
  type: 'System15from16',
  desc: '16 femtonlingar',
  count: 15,
  amount: 16,
  a: 16
}, {
  title: 'System 2/17',
  type: 'System2from17',
  desc: '136 dubblar',
  count: 2,
  amount: 136,
  a: 17
}, {
  title: 'System 3/17',
  type: 'System3from17',
  desc: '680 tripplar',
  count: 3,
  amount: 680,
  a: 17
}, {
  title: 'System 4/17',
  type: 'System4from17',
  desc: '2380 fyrlingar',
  count: 4,
  amount: 2380,
  a: 17
}, {
  title: 'System 5/17',
  type: 'System5from17',
  desc: '6188 femlingar',
  count: 5,
  amount: 6188,
  a: 17
}, {
  title: 'System 6/17',
  type: 'System6from17',
  desc: '12376 sexlingar',
  count: 6,
  amount: 12376,
  a: 17
}, {
  title: 'System 7/17',
  type: 'System7from17',
  desc: '19448 sjulingar',
  count: 7,
  amount: 19448,
  a: 17
}, {
  title: 'System 8/17',
  type: 'System8from17',
  desc: '24310 åttlingar',
  count: 8,
  amount: 24310,
  a: 17
}, {
  title: 'System 9/17',
  type: 'System9from17',
  desc: '24310 nilingar',
  count: 9,
  amount: 24310,
  a: 17
}, {
  title: 'System 10/17',
  type: 'System10from17',
  desc: '19448 tilingar',
  count: 10,
  amount: 19448,
  a: 17
}, {
  title: 'System 11/17',
  type: 'System11from17',
  desc: '12376 elvalingar',
  count: 11,
  amount: 12376,
  a: 17
}, {
  title: 'System 12/17',
  type: 'System12from17',
  desc: '6188 tolvlingar',
  count: 12,
  amount: 6188,
  a: 17
}, {
  title: 'System 13/17',
  type: 'System13from17',
  desc: '2380 trettonlingar',
  count: 13,
  amount: 2380,
  a: 17
}, {
  title: 'System 14/17',
  type: 'System14from17',
  desc: '680 fjortonlingar',
  count: 14,
  amount: 680,
  a: 17
}, {
  title: 'System 15/17',
  type: 'System15from17',
  desc: '136 femtonlingar',
  count: 15,
  amount: 136,
  a: 17
}, {
  title: 'System 16/17',
  type: 'System16from17',
  desc: '17 sextonlingar',
  count: 16,
  amount: 17,
  a: 17
}, {
  title: 'System 2/18',
  type: 'System2from18',
  desc: '153 dubblar',
  count: 2,
  amount: 153,
  a: 18
}, {
  title: 'System 3/18',
  type: 'System3from18',
  desc: '816 tripplar',
  count: 3,
  amount: 816,
  a: 18
}, {
  title: 'System 4/18',
  type: 'System4from18',
  desc: '3060 fyrlingar',
  count: 4,
  amount: 3060,
  a: 18
}, {
  title: 'System 5/18',
  type: 'System5from18',
  desc: '8568 femlingar',
  count: 5,
  amount: 8568,
  a: 18
}, {
  title: 'System 6/18',
  type: 'System6from18',
  desc: '18564 sexlingar',
  count: 6,
  amount: 18564,
  a: 18
}, {
  title: 'System 7/18',
  type: 'System7from18',
  desc: '31824 sjulingar',
  count: 7,
  amount: 31824,
  a: 18
}, {
  title: 'System 8/18',
  type: 'System8from18',
  desc: '43758 åttlingar',
  count: 8,
  amount: 43758,
  a: 18
}, {
  title: 'System 9/18',
  type: 'System9from18',
  desc: '48620 nilingar',
  count: 9,
  amount: 48620,
  a: 18
}, {
  title: 'System 10/18',
  type: 'System10from18',
  desc: '43758 tilingar',
  count: 10,
  amount: 43758,
  a: 18
}, {
  title: 'System 11/18',
  type: 'System11from18',
  desc: '31824 elvalingar',
  count: 11,
  amount: 31824,
  a: 18
}, {
  title: 'System 12/18',
  type: 'System12from18',
  desc: '18564 tolvlingar',
  count: 12,
  amount: 18564,
  a: 18
}, {
  title: 'System 13/18',
  type: 'System13from18',
  desc: '8568 trettonlingar',
  count: 13,
  amount: 8568,
  a: 18
}, {
  title: 'System 14/18',
  type: 'System14from18',
  desc: '3060 fjortonlingar',
  count: 14,
  amount: 3060,
  a: 18
}, {
  title: 'System 15/18',
  type: 'System15from18',
  desc: '816 femtonlingar',
  count: 15,
  amount: 816,
  a: 18
}, {
  title: 'System 16/18',
  type: 'System16from18',
  desc: '153 sextonlingar',
  count: 16,
  amount: 153,
  a: 18
}, {
  title: 'System 17/18',
  type: 'System17from18',
  desc: '18 sjuttonlingar',
  count: 17,
  amount: 18,
  a: 18
}, {
  title: 'System 2/19',
  type: 'System2from19',
  desc: '171 dubblar',
  count: 2,
  amount: 171,
  a: 19
}, {
  title: 'System 3/19',
  type: 'System3from19',
  desc: '969 tripplar',
  count: 3,
  amount: 969,
  a: 19
}, {
  title: 'System 4/19',
  type: 'System4from19',
  desc: '3876 fyrlingar',
  count: 4,
  amount: 3876,
  a: 19
}, {
  title: 'System 5/19',
  type: 'System5from19',
  desc: '11628 femlingar',
  count: 5,
  amount: 11628,
  a: 19
}, {
  title: 'System 6/19',
  type: 'System6from19',
  desc: '27132 sexlingar',
  count: 6,
  amount: 27132,
  a: 19
}, {
  title: 'System 7/19',
  type: 'System7from19',
  desc: '50388 sjulingar',
  count: 7,
  amount: 50388,
  a: 19
}, {
  title: 'System 8/19',
  type: 'System8from19',
  desc: '75582 åttlingar',
  count: 8,
  amount: 75582,
  a: 19
}, {
  title: 'System 9/19',
  type: 'System9from19',
  desc: '92378 nilingar',
  count: 9,
  amount: 92378,
  a: 19
}, {
  title: 'System 10/19',
  type: 'System10from19',
  desc: '92378 tilingar',
  count: 10,
  amount: 92378,
  a: 19
}, {
  title: 'System 11/19',
  type: 'System11from19',
  desc: '75582 elvalingar',
  count: 11,
  amount: 75582,
  a: 19
}, {
  title: 'System 12/19',
  type: 'System12from19',
  desc: '50388 tolvlingar',
  count: 12,
  amount: 50388,
  a: 19
}, {
  title: 'System 13/19',
  type: 'System13from19',
  desc: '27132 trettonlingar',
  count: 13,
  amount: 27132,
  a: 19
}, {
  title: 'System 14/19',
  type: 'System14from19',
  desc: '11628 fjortonlingar',
  count: 14,
  amount: 11628,
  a: 19
}, {
  title: 'System 15/19',
  type: 'System15from19',
  desc: '3876 femtonlingar',
  count: 15,
  amount: 3876,
  a: 19
}, {
  title: 'System 16/19',
  type: 'System16from19',
  desc: '969 sextonlingar',
  count: 16,
  amount: 969,
  a: 19
}, {
  title: 'System 17/19',
  type: 'System17from19',
  desc: '171 sjuttonlingar',
  count: 17,
  amount: 171,
  a: 19
}, {
  title: 'System 18/19',
  type: 'System18from19',
  desc: '19 artonglingar',
  count: 18,
  amount: 19,
  a: 19
}, {
  title: 'System 2/20',
  type: 'System2from20',
  desc: '190 dubblar',
  count: 2,
  amount: 190,
  a: 20
}, {
  title: 'System 3/20',
  type: 'System3from20',
  desc: '1140 tripplar',
  count: 3,
  amount: 1140,
  a: 20
}, {
  title: 'System 4/20',
  type: 'System4from20',
  desc: '4845 fyrlingar',
  count: 4,
  amount: 4845,
  a: 20
}, {
  title: 'System 5/20',
  type: 'System5from20',
  desc: '15504 femlingar',
  count: 5,
  amount: 15504,
  a: 20
}, {
  title: 'System 6/20',
  type: 'System6from20',
  desc: '38760 sexlingar',
  count: 6,
  amount: 38760,
  a: 20
}, {
  title: 'System 7/20',
  type: 'System7from20',
  desc: '77520 sjulingar',
  count: 7,
  amount: 77520,
  a: 20
}, {
  title: 'System 8/20',
  type: 'System8from20',
  desc: '125970 åttlingar',
  count: 8,
  amount: 125970,
  a: 20
}, {
  title: 'System 9/20',
  type: 'System9from20',
  desc: '167960 nilingar',
  count: 9,
  amount: 167960,
  a: 20
}, {
  title: 'System 10/20',
  type: 'System10from20',
  desc: '184756 tilingar',
  count: 10,
  amount: 184756,
  a: 20
}, {
  title: 'System 11/20',
  type: 'System11from20',
  desc: '167960 elvalingar',
  count: 11,
  amount: 167960,
  a: 20
}, {
  title: 'System 12/20',
  type: 'System12from20',
  desc: '125970 tolvlingar',
  count: 12,
  amount: 125970,
  a: 20
}, {
  title: 'System 13/20',
  type: 'System13from20',
  desc: '77520 trettonlingar',
  count: 13,
  amount: 77520,
  a: 20
}, {
  title: 'System 14/20',
  type: 'System14from20',
  desc: '38760 fjortonlingar',
  count: 14,
  amount: 38760,
  a: 20
}, {
  title: 'System 15/20',
  type: 'System15from20',
  desc: '15504 femtonlingar',
  count: 15,
  amount: 15504,
  a: 20
}, {
  title: 'System 16/20',
  type: 'System16from20',
  desc: '4845 sextonlingar',
  count: 16,
  amount: 4845,
  a: 20
}, {
  title: 'System 17/20',
  type: 'System17from20',
  desc: '1140 sjuttonlingar',
  count: 17,
  amount: 1140,
  a: 20
}, {
  title: 'System 18/20',
  type: 'System18from20',
  desc: '190 artonglingar',
  count: 18,
  amount: 190,
  a: 20
}, {
  title: 'System 19/20',
  type: 'System19from20',
  desc: '20 nittonlingar',
  count: 19,
  amount: 20,
  a: 20
}, {
  title: 'Trixie',
  type: 'Trixie',
  desc: '3 dubblar och 1 trippel',
  count: 4,
  amount: 3,
  a: [[0, 1], [0, 2], [1, 2], [0, 1, 2]]
}, {
  title: 'Patent',
  type: 'Patent',
  desc: '3 singlar, 3 dubblar och 1 trippel',
  count: 7,
  amount: 3,
  a: [[0], [1], [2], [0, 1], [0, 2], [1, 2], [0, 1, 2]]
}, {
  title: 'Yankee',
  type: 'Yankee',
  desc: '6 dubblar, 4 tripplar och 1 fyrling',
  count: 11,
  amount: 4,
  a: [[0, 1], [0, 2], [0, 3], [1, 2], [1, 3], [2, 3], [0, 1, 2], [0, 2, 3], [0, 1, 3], [1, 2, 3], [0, 1, 2, 3]]
}, {
  title: 'Lucky 15',
  type: 'Lucky15',
  desc: '4 singlar, 6 dubblar, 4 tripplar och 1 fyrling',
  count: 15,
  amount: 4,
  a: [[0], [1], [2], [3], [0, 1], [0, 2], [0, 3], [1, 2], [1, 3], [2, 3], [1, 2, 3], [0, 2, 3], [0, 1, 3], [1, 2, 3], [0, 1, 2, 3]]
}, {
  title: 'Super Yankee',
  type: 'SuperYankee',
  desc: '10 dubblar, 10 tripplar, 5 fyrlingar och 1 femling',
  count: 26,
  amount: 5,
  a: []
}, {
  title: 'Lucky 31',
  type: 'Lucky31',
  desc: '5 singlar, 10 dubblar, 10 tripplar, 5 fyrlingar och 1 femling',
  count: 31,
  amount: 5,
  a: []
}, {
  title: 'Heinz',
  type: 'Heinz',
  desc: '15 dubblar, 20 tripplar, 15 fyrlingar, 6 femlingar och 1 sexling',
  count: 57,
  amount: 6,
  a: []
}, {
  title: 'Lucky 63',
  type: 'Lucky63',
  desc: '6 singlar, 15 dubblar, 20 tripplar, 15 fyrlingar, 6 femlingar och 1 sexling',
  count: 63,
  amount: 6,
  a: []
}, {
  title: 'Super Heinz',
  type: 'SuperHeinz',
  desc: '21 dubblar, 35 tripplar, 35 fyrlingar, 21 femlingar, 7 sexlingar och 1 sjuling',
  count: 120,
  amount: 7,
  a: []
}, {
  title: 'Goliath',
  type: 'Goliath',
  desc: '28 dubblar, 56 tripplar, 70 fyrlingar, 56 femlingar, 28 sexlingar, 8 sjulingar och 1 åttling',
  count: 247,
  amount: 8,
  a: []
}];
const getTitleFromBet = _ref => {
  let {
    betType,
    numberOfBets,
    selections
  } = _ref;
  const selectionLength = (selections === null || selections === void 0 ? void 0 : selections.length) || 0;
  const typeSelection = oddsetWagerModels.filter(model => model.type === betType);
  if (typeSelection.length === 1) {
    return typeSelection[0].title;
  }
  const betSelection = typeSelection.filter(model => model.count === selectionLength && model.amount === numberOfBets);
  if (betSelection.length === 0) {
    return '';
  }
  return betSelection[0].title;
};
svs.sportsbook.sbtech_api_impl.utils.getTitleFromBet = getTitleFromBet;
 })(window);